module.exports = __webpack_public_path__ + "img/htcm_14.85841d0c.jpg";